import { buildWhatsAppLink } from "@/utils/links";

export default function WhatsAppFloat() {
  return (
    <a
      href={buildWhatsAppLink("Hola ALÉA, quiero agendar una valoración.")}
      target="_blank"
      rel="noreferrer"
      aria-label="Agendar por WhatsApp"
      className="cta-primary group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-[16px] bg-primary-500 py-3.5 pl-4 pr-5 text-background-50 transition-all duration-300 hover:bg-primary-600 md:bottom-8 md:right-8"
    >
      <span className="flex h-7 w-7 items-center justify-center">
        <i className="ri-whatsapp-line text-2xl leading-none" />
      </span>
      <span className="hidden whitespace-nowrap font-label text-[11px] font-semibold uppercase tracking-[0.1em] sm:inline">
        Agendar por WhatsApp
      </span>
    </a>
  );
}